import React from "react";
import { useMessageSource } from "react-message-source";
import { PhoneType } from "../../../types";
import InputContainer from "../../../ui/layout/page/forms-container/form-item-container/input-container";
import TypographyContainer from "../../../ui/layout/page/typography-container/typography-base-container";
import TypographyItemContainer from "../../../ui/layout/page/typography-container/typography-item-container";
import CustomLink from "../../../ui/widgets/link";
import CustomTypography from "../../../ui/widgets/typography";
import AddressSelect from "../../shared/components/address-select";
import Country from "../../shared/components/country";
import DropdownField from "../../shared/components/formik/dropdown";
import TextInputField from "../../shared/components/formik/text-input";
import DatePicker from "../../shared/components/formik/text-input/date";
import Phone from "../../shared/components/phone";
import IndustrySector from "../industry-sector";
import { CompanyModel, LegalForm } from "../types";
import { defaultAddress } from "../../shared/defaults";

export default function EnterCompanyForm({
  onBack,
  dataPath,
  company,
}: {
  onBack: () => void;
  dataPath: string;
  company: CompanyModel;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();
  const { address = defaultAddress() } = company;

  return (
    <>
      <TypographyContainer>
        <TypographyItemContainer>
          <CustomTypography variant="body1" className="mandatory-fields-label">
            {getMessage("Company-label.mandatoryFields")}
          </CustomTypography>
        </TypographyItemContainer>
      </TypographyContainer>
      <InputContainer>
        <TextInputField
          name={`${dataPath}name`}
          label={getMessage("Company.legalName")}
        />
      </InputContainer>
      <AddressSelect
        fullStreet={company.fullStreet}
        address={address}
        dataPath={dataPath}
        isBusinessAddress
      />
      <InputContainer>
        <Country dataPath={dataPath} value={address.country} forCompany />
      </InputContainer>
      <InputContainer>
        <Phone
          dataPath={dataPath}
          value={company.phone as PhoneType}
          forCompany
        />
      </InputContainer>
      <InputContainer>
        <DropdownField
          name={`${dataPath}legalForm`}
          menuItems={[
            {
              value: LegalForm.FOUNDATION,
              children: getMessage("Company.legalForm-foundation"),
            },
            {
              value: LegalForm.SOLE_PROPRIETORSHIP,
              children: getMessage("Company.legalForm-one-man-business"),
            },
            {
              value: LegalForm.ASSOCIATION,
              children: getMessage("Company.legalForm-society"),
            },
          ]}
          selectedItemValue={company.legalForm}
          label={getMessage("Company.legalForm")}
        />
      </InputContainer>
      <IndustrySector dataPath={dataPath} company={company} />
      <InputContainer>
        <DatePicker
          isFullDate={false}
          label={getMessage("Company.foundation")}
          id="company-founded-on"
          name={`${dataPath}foundationDate`}
          value={company.foundationDate}
        />
      </InputContainer>
      <TypographyContainer>
        <TypographyItemContainer>
          <CustomLink data-testid="go-back-button" onClick={onBack}>
            {getMessage("Onboarding.back")}
          </CustomLink>
        </TypographyItemContainer>
      </TypographyContainer>
    </>
  );
}
